import { combineReducers } from '@reduxjs/toolkit'

import { reducer as feedbackDetail } from './feedbackDetail'

export default combineReducers({ feedbackDetail })
